import { Column, DataType, Model, Table } from 'sequelize-typescript'

@Table({
  freezeTableName: true,
  modelName: 'plataforma',
  timestamps: false,
})
export class PlataformaModel extends Model {
  @Column({
    type: DataType.STRING(55),
    allowNull: false,
  })
  nombre!: string

  @Column({
    type: DataType.TINYINT,
    allowNull: false,
  })
  eliminado!: boolean
}
